export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';

export const SET_USER_ROLE = 'SET_USER_ROLE';

export const USER_SEND_RESET_PASSWORD_REQUEST = 'USER_SEND_RESET_PASSWORD_REQUEST';
export const USER_SEND_RESET_PASSWORD_SUCCESS = 'USER_SEND_RESET_PASSWORD_SUCCESS';
export const USER_SEND_RESET_PASSWORD_FAILURE = 'USER_SEND_RESET_PASSWORD_FAILURE';

export const USER_RESET_PASSWORD_REQUEST = 'USER_RESET_PASSWORD_REQUEST';
export const USER_RESET_PASSWORD_SUCCESS = 'USER_RESET_PASSWORD_SUCCESS';
export const USER_RESET_PASSWORD_FAILURE = 'USER_RESET_PASSWORD_FAILURE';

export const USER_GET_AUTH_USER = 'USER_GET_AUTH_USER';
export const USER_GET_AUTH_USER_SUCCESS = 'USER_GET_AUTH_USER_SUCCESS';
export const USER_GET_AUTH_USER_FAILURE = 'USER_GET_AUTH_USER_FAILURE';

export const USER_SIGNUP_REQUEST = 'USER_SIGNUP_REQUEST';
export const USER_SIGNUP_SUCCESS = 'USER_SIGNUP_SUCCESS';
export const USER_SIGNUP_FAILURE = 'USER_SIGNUP_FAILURE';

// Phone confirmation
export const USER_CONFIRM_PHONE_REQUEST = 'USER_CONFIRM_PHONE_REQUEST';
export const USER_CONFIRM_PHONE_SUCCESS = 'USER_CONFIRM_PHONE_SUCCESS';
export const USER_CONFIRM_PHONE_FAILURE = 'USER_CONFIRM_PHONE_FAILURE';

// Change email
export const USER_CHANGE_EMAIL_REQUEST = 'USER_CHANGE_EMAIL_REQUEST';
export const USER_CHANGE_EMAIL_SUCCESS = 'USER_CHANGE_EMAIL_SUCCESS';
export const USER_CHANGE_EMAIL_FAILURE = 'USER_CHANGE_EMAIL_FAILURE';

// Email code resend
export const USER_RESEND_EMAIL_CODE_REQUEST = 'USER_RESEND_EMAIL_CODE_REQUEST';
export const USER_RESEND_EMAIL_CODE_SUCCESS = 'USER_RESEND_EMAIL_CODE_SUCCESS';
export const USER_RESEND_EMAIL_CODE_FAILURE = 'USER_RESEND_EMAIL_CODE_FAILURE';

// Change phone
export const USER_CHANGE_PHONE_REQUEST = 'USER_CHANGE_PHONE_REQUEST';
export const USER_CHANGE_PHONE_SUCCESS = 'USER_CHANGE_PHONE_SUCCESS';
export const USER_CHANGE_PHONE_FAILURE = 'USER_CHANGE_PHONE_FAILURE';

export const USER_FINISH_PHONE_REQUEST = 'USER_FINISH_PHONE_REQUEST';
export const USER_FINISH_PHONE_SUCCESS = 'USER_FINISH_PHONE_SUCCESS';
export const USER_FINISH_PHONE_FAILURE = 'USER_FINISH_PHONE_FAILURE';

// Phone code resend
export const USER_RESEND_PHONE_CODE_REQUEST = 'USER_RESEND_PHONE_CODE_REQUEST';
export const USER_RESEND_PHONE_CODE_SUCCESS = 'USER_RESEND_PHONE_CODE_SUCCESS';
export const USER_RESEND_PHONE_CODE_FAILURE = 'USER_RESEND_PHONE_CODE_FAILURE';


// Email confirmation
export const USER_CONFIRM_EMAIL_REQUEST = 'USER_CONFIRM_EMAIL_REQUEST';
export const USER_CONFIRM_EMAIL_SUCCESS = 'USER_CONFIRM_EMAIL_SUCCESS';
export const USER_CONFIRM_EMAIL_FAILURE = 'USER_CONFIRM_EMAIL_FAILURE';
